module.exports = __webpack_public_path__ + "img/gh-43160-3-24.prt.25d846dd.jpg";